import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import FormInput from './fields/input-field';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';
import DateInput from './fields/date-field';
import moment from 'moment';
import {date_time_format} from '../../utils/constants';
import SelectInput from './fields/select-field';


class GameForm extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        leagues: PropTypes.array
    };
    onSubmit = (values) => {
        if (values.date) {
            values.date = moment(values.date).format(date_time_format);
        }
        return this.props.onSubmit(values);
    };

    render() {
        const {error, handleSubmit, submitting, leagues} = this.props;
        return (
            <form onSubmit={handleSubmit(this.onSubmit)} className="form">
                {error && <div className="global-error">{error}</div>}
                <div className="login-form">
                    <div className="inline-form-row">
                        <Field name="home_team" component={FormInput} label={'Namų komanda'} type="text"/>
                        <Field name="away_team" component={FormInput} label={'Svečių komanda'} type="text"/>
                    </div>
                    <Field name="league" component={SelectInput} label={'Lyga'} type="text" options={leagues}/>
                    <Field name="address" component={FormInput} label={'Adresas'} type="text"/>
                    <Field name="date" component={DateInput} label={'Data'} type="text" time={true}/>
                    <Field name="comment" component={DateInput} label={'Komentaras'} type="text" time={true}/>

                </div>
                <div className="row centered form-actions">
                    <Button submit={true} loading={submitting} disabled={submitting}>
                        Išsaugoti
                    </Button>
                </div>
            </form>
        );
    }
}

const validate = values => {
    let errors = {};
    errors = validateRequiredFields(values, [
        'username', 'password'
    ], errors);

    return errors;
};

GameForm = reduxForm({
    form: 'game_form',
    validate
})(GameForm);
export default GameForm;



// WEBPACK FOOTER //
// ./src/js/components/form/game-form.jsx